import React from "react";
import { GlobalProvider } from "./src/context/GlobalContext";
import Layout from "./src/components/Layout";
import { initialiseScanningAds } from "./src/sections/scanning/adsTracking";

export const wrapPageElement = ({ element, props }) => {
  // props provide same data to Layout as Page element will get
  // including location, data, etc - you don't need to pass it
  return <Layout {...props}>{element}</Layout>;
};

export const wrapRootElement = ({ element }) => (
  <GlobalProvider>{element}</GlobalProvider>
);

/*
 * GA4 on a Gatsby SPA.
 *
 * The tag in src/html.js fires one page_view on the hard load and nothing after
 * that; every subsequent navigation is client-side. Enhanced measurement's
 * history-change trigger picks some of these up, but it is off by default on
 * older properties and it reports the URL before the title updates. Sending it
 * ourselves is the only reliable version.
 *
 * onRouteUpdate also runs on the initial load, so page_view is suppressed there
 * to avoid double-counting the first page of every session.
 */
let isFirstRoute = true;

export const onRouteUpdate = ({ location }) => {
  initialiseScanningAds();
  if (typeof window.gtag !== "function") return;

  if (isFirstRoute) {
    isFirstRoute = false;
    return;
  }

  window.gtag("event", "page_view", {
    page_path: location.pathname + location.search,
    page_location: window.location.href,
    page_title: document.title,
  });
};

/*
 * Signup CTA clicks.
 *
 * 91 links across this site point at members.hotsnail.com.au/signup. Cross-domain
 * linking (src/html.js) keeps the session intact across the hop, but it does not
 * tell us which page pushed someone over -- and that is exactly the question the
 * SEO work needs answered. One delegated listener covers every CTA, including
 * ones added later, without touching 91 components.
 */
export const onClientEntry = () => {
  document.addEventListener(
    "click",
    event => {
      const link = event.target.closest && event.target.closest("a[href]");
      if (!link || typeof window.gtag !== "function") return;
      if (link.href.indexOf("members.hotsnail.com.au") === -1) return;

      window.gtag("event", "signup_cta_click", {
        link_url: link.href,
        link_text: (link.textContent || "").trim().slice(0, 100),
        source_page: window.location.pathname,
      });
    },
    true
  );
};
